export default __webpack_public_path__ + "static/media/22.533aa1e7.png";